import { createContext } from "react";

export const ExportModeContext = createContext(false);
